
import React, {Component} from 'react';
import {Modal,FormControl,Button,ButtonToolbar} from 'react-bootstrap'

import FontAwesome from 'react-fontawesome'
import SWTCustomerPage from './SWTCustomerPage'


class SWTNewCustomerModal extends Component {

  constructor(...args){
    super(...args)
    this.state = {}

    //this.openPopup() 
  }

  openPopup(){
    // console.log("ref",this.refs.swtCustPop)
    //this.refs.swtCustPage.loadPage()
  }

  onSelectCustomerItem(item){
    if(typeof this.props.onSelect !=='undefined'){
      this.props.onSelect(item)
    }else if(window.onSelectCustomerItem!==undefined){
      window.onSelectCustomerItem(item)
    }
    if(this.props.onHide!==undefined)
      this.props.onHide()
  }

  render(){
    let {show,showNew} = this.props
    
    return (
      <Modal show={show} enforceFocus={false} onHide={this.props.onHide} dialogClassName="midwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{'ค้นหาลูกค้า'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SWTCustomerPage ref={'swtCustPage'} showNew={showNew} onSelectItem={this.onSelectCustomerItem.bind(this)}/>
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
    )
  }
}


export default SWTNewCustomerModal;





// WEBPACK FOOTER //
// ./src/view/workdoc/SWTNewCustomerModal.js